import React from "react";
import { Modal } from "react-bootstrap";
import { IKidsComboSelectionData } from "../../../models/kidsCombo";
import ChoseItemModal from "./ChoseItemModal";
import styleClasses from "../ItemSelection/kidsCombo.module.scss"

interface IItemSelectionModalProps {
  chosseitem: boolean;
  setChosseItem: (value: boolean) => void;
  setIsCustomize: (value: boolean) => void;
  isCustomize: boolean;
  chooseHandleClose: () => void;
  handleIngredientSelection: (data: any, id?: string) => void;
  selectedItemId: string;
  selectionData: IKidsComboSelectionData[];
  itemData: any;
}

const ItemSelectionModal: React.FC<IItemSelectionModalProps> = ({
  isCustomize,
  selectedItemId,
  selectionData,
  itemData,
  chosseitem,
  chooseHandleClose,
  handleIngredientSelection,
  setChosseItem,
  setIsCustomize
}) => {

  const chooseName = selectionData.filter((selectionItem) => selectionItem.id === selectedItemId)[0]?.chooseName;

  return (
    <Modal
      show={chosseitem}
      onHide={chooseHandleClose}
      centered
      size="xl"
      className="kids-combo-modal chose-item-modal theme-modal-style app_container_wrap no-padding border-radius-15 border-radius-sm-8"
    >
      <Modal.Header className="pt-0" id="close_button2">
        <button
          type="button"
          className="btn modal-close-button pe-0 blue-icon"
          onClick={chooseHandleClose}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body className = {`text-center py-4 ${styleClasses.kids_item_space}`}>
        <ChoseItemModal
          isCustomize={isCustomize}
          selectedItemId={selectedItemId}
          chooseName={chooseName}
          itemModifierGroups={itemData?.items_modifier_groups}
          handleIngredientSelection={handleIngredientSelection}
          setChosseItem={setChosseItem}
          setIsCustomize={setIsCustomize}
          chooseHandleClose={chooseHandleClose}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ItemSelectionModal;
